import { useTranslation } from 'react-i18next'

import { useUk } from '../../../../../hooks'
import { brToNewLine } from '../../../../../utils/common'
import {
  getUserStaffInvitationFormInitialValues,
  USER_INVITATION_FORM_FIELD_NAME_MESSAGE,
  USER_INVITATION_FORM_FIELD_NAME_SUBJECT,
  UserInvitationFormModal,
  UserStaffInvitationFormModal,
  useUserProfileContext,
} from '../../../../User'
import { USER_PROFILE_PAGE_HEADER_FOOTER_ACTION } from '../../UserProfilePageHeaderFooter.constants'

import { getUserInvitationPayload } from './useUserProfilePageSendInviteAction.utils'

export function useUserProfilePageSendInviteAction({
  handlePerformMassAction,
}) {
  const { t } = useTranslation()

  const { handleCloseModal, setModal, userData } = useUserProfileContext()

  const ukData = useUk()

  const initialValues = {
    [USER_INVITATION_FORM_FIELD_NAME_MESSAGE]: brToNewLine(
      ukData.config.invitation_text_for_dwellers
    ),
    [USER_INVITATION_FORM_FIELD_NAME_SUBJECT]:
      ukData.config.invitation_subject_for_dwellers,
  }

  const staffInitialValues = getUserStaffInvitationFormInitialValues({
    t,
    ukLang: ukData.language.code,
    ukName: ukData.name,
  })

  function handleSubmitInvitation(values) {
    handlePerformMassAction({
      action: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite,
      payload: getUserInvitationPayload(values),
    })
  }

  function handleClickSendInvite() {
    setModal(
      userData.isStaff ? (
        <UserStaffInvitationFormModal
          initialValues={staffInitialValues}
          submitButtonText='Modal.SendBtnKey'
          onClose={handleCloseModal}
          onSubmit={handleSubmitInvitation}
        />
      ) : (
        <UserInvitationFormModal
          initialValues={initialValues}
          submitButtonText='Modal.SendBtnKey'
          onClose={handleCloseModal}
          onSubmit={handleSubmitInvitation}
        />
      )
    )
  }

  return { handleClickSendInvite }
}
